import { render, staticRenderFns } from "./BusinessCardReaderDelete.vue?vue&type=template&id=8590043a"
import script from "./BusinessCardReaderDelete.vue?vue&type=script&lang=js"
export * from "./BusinessCardReaderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports